export default {
    approvals: "Jóváhagyások",
    delegates: "küldöttek",
    employees: "Alkalmazottak"
}